import React, { useState, useEffect } from 'react'
import { Box, Text } from 'grommet'

import TTJsonTree from '../common/TTJsonTree'
import TTabSub from '../common/TTabSub'




import TriageViewLogHistory from './TriageViewLogHistory'
import TriageViewResult from './TriageViewResult'
import TriageSnapshotResult from './TriageSnapshotResult'
import TriageGroupSnapshot from './TriageGroupSnapshot'
import TriageGroupResult from './jobtask/recent/TriageGroupResult'
import FixParserHome from '../fix/FixParserHome'
import TriageProgressView from '../triage/TriageProgressView'
import TriagePSClientResult from './TriagePSClientResult'
import TriageRoutingLibaryResult from './TriageRoutingLibraryResult'
import TriageKibanaView from './TriageKibanaView'
import TriageCompare from './TriageCompare'

import TriageHistoryViewLog from './jobtask/history/TriageHistoryViewLog'
import TriageHistoryViewResult from './jobtask/history/TriageHistoryViewResult'

const ParamsComponent = ({ data, objkey }) => {
  let parmobj = {}

  if (objkey !== 'Params') {
    parmobj = data[objkey]
  }
  else if (typeof (JSON.parse(data[objkey])) === 'object') {
    parmobj = JSON.parse(data[objkey])
  } else {
    parmobj = JSON.parse(JSON.parse(data[objkey]))
  }

  return (
    <Box fill={true} direction="row" wrap={true} gap="small">
      {objkey === 'Params' ?
        <TTJsonTree data={parmobj} expandAll={true} />
        : parmobj
      }
    </Box>
  )
}

const TriageCommandsEachCommandDetail = ({ detailView, defaultSubTab }) => {
  const [selectedSubTab, setSelectedSubTab] = useState(defaultSubTab ? defaultSubTab : "Log")

  useEffect(() => {
    setSelectedSubTab(defaultSubTab ? defaultSubTab : "Log")
  }, [defaultSubTab, detailView])

  return (
    <>

      <Box name="tabletab" gap="small" alignContent="start" background="light-2" fill="vertical" >
        <Box flex={false} fill="horizontal" direction="row">
          {detailView.head &&
            <Box direction="row" fill="horizontal" background="light-3" border="horizontal" pad="xsmall" gap="xsmall">
              {Object.keys(detailView.head).map(headKey => (
                <Box flex={false} key={headKey} direction="row" gap="small">

                  <Box width="500px">

                    <Text size="xsmall" weight="bold" color="brand">
                      {headKey}
                    </Text>

                    <ParamsComponent
                      data={detailView.head}
                      objkey={headKey}
                    />

                  </Box>

                </Box>
              ))}
            </Box>
          }
        </Box>

        <Box margin={{ bottom: 'small' }} direction="row" align="start" justify="start">
          {detailView.data &&
            detailView.data.map(data => (
              <TTabSub
                key={data.subheader}
                subTabName={data.subheader}
                handleClickSubTab={() => setSelectedSubTab(data.subheader)}
                selected={selectedSubTab === data.subheader}
              />
            ))}
        </Box>
        <Box key="detailView" height="95%" overflow={{ horizontal: 'hidden', vertical: 'auto' }} background="light-2">

          {detailView.data &&
            detailView.data.map(data => {
              if (selectedSubTab === data.subheader && data.content) {
                switch (data.type) {
                  case 'json':
                    return <TTJsonTree key={data.subheader + '_data'} data={data.content} />
                  case 'triage_log':
                    return <TriageViewLogHistory key={data.subheader + '_data'} taskid={data.content} />
                  case 'triage_result':
                    return <TriageViewResult key={data.subheader + '_data'} content={data.content} />
                  case 'triage_history_result':
                    return <TriageHistoryViewResult key={data.subheader + '_data'} content={data.content} />
                  case 'triage_history_log':
                    return <TriageHistoryViewLog key={data.subheader + '_data'} content={data.content} />
                  case 'triage_kibana_view':
                    return <TriageKibanaView key={data.subheader + '_data'} content={data.content} />
                  case 'triage_group_result':
                    return <TriageGroupResult key={data.subheader + '_data'} content={data.content} />
                  case 'triage_snapshot_result':
                    return <TriageSnapshotResult key={data.subheader + '_data'} content={data.content} />
                  case 'triage_routing_library_parser':
                    return <TriageRoutingLibaryResult key={data.subheader + '_data'} content={data.content} />
                  case 'triage_psclient_result':
                    return <TriagePSClientResult key={data.subheader + '_data'} content={data.content} />
                  case 'triage_group_snapshot':
                    return <TriageGroupSnapshot key={data.subheader + '_data'} content={data.content} />
                  case 'triage_progress_view':
                    return <TriageProgressView key={data.subheader + '_data'} content={data.content} />
                  case 'triage_fix_parser':
                    return <FixParserHome key={data.subheader + '_data'} content={data.content} />
                  case 'triage_compare':
                    return <TriageCompare key={data.subheader + '_data'} content={data.content} />
                  default:
                    return (<Box key="dataTypeDefault" />)
                }
              } else {
                return (<Box key={"noContentDefault" + data.type} />)
              }
            })}
        </Box>
      </Box>
    </>
  )
}

export default TriageCommandsEachCommandDetail
